import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';
import { PlaceholderCard } from "../styles";
const CardPlaceholder = () => {

    return (
        <PlaceholderCard>
            <Skeleton height={28} width="100%" />
            <Skeleton height={24} width="100%" />
            <Skeleton height={16} width="100%" />

            <Skeleton height={1} width="100%" />

            <Skeleton height={40} width="100%" borderRadius={8} />

            <Skeleton height={1} width="100%" />

            {[...Array(5)].map((_, i) => (
                <Skeleton key={i} height={18} width={`100%`} />
            ))}
        </PlaceholderCard>
    );
};

export default CardPlaceholder;
